module.exports = __webpack_public_path__ + "DINNextLTPro-LightCondensed.ttf?6ef3717d648fa3632df44216e3844ce4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-LightCondensed.ttf
// module id = 1435
// module chunks = 0